import axios from 'axios'


// // for development 
// export const BASE_URL = "http://localhost:5000/api/";
// export const ImageUrl = "http://localhost:5000/file/images/";

// for development by internet ipaddress
// export const BASE_URL = 'http://192.168.218.60:5000/api/';
// export const ImageUrl = 'http://192.168.218.60:5000/file/images/';

// for production
export const BASE_URL = "https://mernbackend.labzy.cloud/api/";
export const ImageUrl = "https://mernbackend.labzy.cloud/file/images/";

const TOKEN = localStorage.getItem("UserDetailToken");

export const publicRequest = axios.create({
    baseUrl: BASE_URL,
})

export const userRequest = axios.create({
    baseUrl: BASE_URL,
    headers:  {token: `Bearer ${TOKEN}`},
})